<template>
<div>
    <el-row :gutter="24">
        <el-col :span="16">
            <el-input v-model="amount" placeholder="请输入转换金额" 
            @keyup.enter.native="convert"
            type="number"
            min="0"></el-input>
        </el-col>
        <el-col :span="6">
            <el-select v-model="code" placeholder="请选择币种" @change="convert">
                <el-option
                    v-for="item in currencies"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                </el-option>
            </el-select>
        </el-col>
        <el-col :span="2">
            <el-button v-if="loading" type="primary" :loading="true">转换中</el-button>
            <el-button v-else type="primary" @click="convert">转换</el-button>
        </el-col>
    </el-row>
    <el-row :gutter="24">
        <el-col :span="8" :offset="16">
            <div id="updatetime">{{updatetime}}</div>
        </el-col>
    </el-row>
    <el-row :gutter="24">
        <el-col :span="24">
        <el-table
            :data="tableData"
            stripe
            style="width:100%">
            <el-table-column 
                prop="name"
                label="币种">
            </el-table-column>
            <el-table-column
                prop="amount"
                label="金额">
            </el-table-column>
        </el-table>
        </el-col>
    </el-row>
</div>
</template>

<script>
export default {
    data(){
        return{
            conversionApi:'https://api.huobizh.com/conversion',
            currencylistApi:'https://api.huobizh.com/list',
            code:'CNY',
            amount:100,
            currencies:[],
            tableData:[],
            loading:false,
            updatetime:''
        }
    },
    mounted(){
        this.init()
    },
    methods:{
        init(){
            this.getCurrencyList()
            if(localStorage.code){
                this.code=localStorage.code
            }
            if(localStorage.amount){
                this.amount=localStorage.amount
            }
            this.convert()
        },
        getCurrencyList(){
            this.axios
                .get(this.currencylistApi)
                .then(response=>{
                    let data=response.data.data
                    for(let i=0;i<data.length;i++)
                    {
                        let item=data[i]
                        this.currencies.push({
                            'code': item.code,
                            'name': item.name+'('+item.code+')'
                        })
                    }
                })
        },
        convert(){
            this.loading=true
            localStorage.code=this.code
            localStorage.amount=this.amount
            this.axios
                .get(this.conversionApi+'/'+this.code+'/'+this.amount)
                .then(response=>{
                    let data=response.data.data
                    let tempData=[]
                    if(data)
                    {
                        for(let i=0;i<data.length;i++)
                        {
                            let item=data[i]
                            tempData.push({
                                'amount': item.currency_symbol+' '+item.amount,
                                'name': item.currency_name+'('+item.currency_code+')'
                            })
                        }
                        this.tableData=tempData
                        this.updatetime='汇率更新于'+new Date(data[0].updatetime).format("yyyy-MM-dd hh:mm:ss")
                    }
                    else{
                        this.tableData=[]
                    }
                    this.loading=false
                })
        }
    }
}
</script>

<style>
.el-table th{
    text-align: center;
    color:#6E6E6E
}
#updatetime{
    text-align: right;
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    color: #606266;
}
</style>
